import { useEffect } from 'react';

// NOTE: CrowdHandler is a virtual waiting room service used to manage heavy traffic loads.
// It is currently not used.
const useCrowdHandler = () => {
  useEffect(() => {
    if (import.meta.env.PROD) {
      // const script = document.createElement('script');
      // script.src =
      //   'https://wait.crowdhandler.com/js/latest/lite-validator/main.js?id=d9ff1dda71a3b8cabea34e43916676d58d444e919e7639b1634c370751e86b07&spa=true';
      // script.async = true;
      // document.head.appendChild(script);
      // console.log('yes');

      return () => {
        // document.head.removeChild(script);
      };
    }
  }, []);
};

export default useCrowdHandler;
